/**
 * Effect Tokens
 * 
 * Reusable visual effects like shadows and other layer effects.
 * 
 * Based on Figma variable collection: Effects
 */

export type ShadowLayer = {
  color: string;
  offsetX: number;
  offsetY: number;
  blurRadius: number;
  spread?: number;
};

export const shadowLayers: ShadowLayer[] = [
  {
    color: '#BFBFBF1A', // rgba(191, 191, 191, 0.102)
    offsetX: 0,
    offsetY: 7,
    blurRadius: 14,
    spread: 0,
  },
  {
    color: '#BFBFBF17', // rgba(191, 191, 191, 0.090)
    offsetX: 0,
    offsetY: 26,
    blurRadius: 26,
    spread: 0,
  },
  {
    color: '#BFBFBF0D', // rgba(191, 191, 191, 0.051)
    offsetX: 0,
    offsetY: 59,
    blurRadius: 35,
    spread: 0,
  },
  {
    color: '#BFBFBF03', // rgba(191, 191, 191, 0.012)
    offsetX: 0,
    offsetY: 104,
    blurRadius: 42,
    spread: 0,
  },
  {
    color: '#BFBFBF00', // rgba(191, 191, 191, 0.000)
    offsetX: 0,
    offsetY: 163,
    blurRadius: 46,
    spread: 0,
  },
];

export const effectTokens = {
  Shadow: shadowLayers,
} as const;

// Type exports for TypeScript support
export type EffectToken = keyof typeof effectTokens;

// Helper function to get shadow as CSS string
export const getShadowCSS = (token: EffectToken = 'Shadow'): string => {
  const layers = effectTokens[token];
  return layers
    .map(
      (layer) =>
        `${layer.offsetX}px ${layer.offsetY}px ${layer.blurRadius}px ${layer.spread || 0}px ${layer.color}`
    )
    .join(', ');
};

// Helper function to get shadow as CSS object (for styled-components, emotion, etc.)
export const getShadow = (token: EffectToken = 'Shadow'): string => {
  return getShadowCSS(token);
};

// Helper function to get shadow layers array
export const getShadowLayers = (token: EffectToken = 'Shadow'): ShadowLayer[] => {
  return effectTokens[token];
};


